import React from 'react'

const PageEntries = ({ start, end, totalCount }) => {
    return (
        <div className="d-md-flex justify-content-between align-items-center dt-layout-start col-md-auto me-auto">
            <div className="dt-info">
                Showing {start} to {end} of {totalCount} entries
            </div>
        </div>
    )
}

export default PageEntries
